import React from "react";
import commentsDefaultUserImage from "../../assets/comments-default-user.png";
import {toast} from 'react-toastify';
import copy from 'copy-to-clipboard';
import translate from "../translations/translations.wrapper.jsx";
import { FilesIcon } from "lucide-react";
import { Button, ButtonType } from "components/common/Button.component";

export function UserProfileTooltip(props) {
    const setFallbackImage = function (event) {
        event.target.src = 'https://static-odp.visma.net/commoncomponents/vismaSkin/images/services/default/medium.png';
    }

    const copyEmail = function () {
        copy(props.user.email);

        toast(`✓ ${props.translate('taskDetail.copiedToClipboard')}`, {
            type: 'dark'
        });
    }

    const profilePictureBaseUrl = typeof window.ENVIRONMENT !== 'undefined' && window.ENVIRONMENT.PROFILE_PICTURE_BASE_URL;
    const profilePicture = props.user.connectUserId ? `${profilePictureBaseUrl}${props.user.connectUserId}?type=initials` : commentsDefaultUserImage;

    return (<div className="d-flex flex-row align-items-center" data-testid="workflow-details-profile-tooltip">
        <div className={"ga-avatar mr-8"}>
            <img src={profilePicture}
                 alt="avatar"
                 onError={(event) => {
                     setFallbackImage(event)
                 }}
            />
        </div>
        <div>
            <div className="ga-tooltip__title">
                {props.user.fullName}{props.children ? "  -  " : ""}{props.children}
            </div>
            {props.user.email &&
                <div className="ga-text-sm d-flex align-items-center w-100">
                    <a href={`mailto:${props.user.email}`}
                       className="text-reset text-break">
                        {props.user.email}
                    </a>
                    <Button type={ButtonType.GHOST}
                            iconOnly={true}
                            icon={<FilesIcon/>}
                            extraClassName={"mx-2 text-reset"}
                            onClick={copyEmail}/>
                </div>
            }
        </div>
    </div>)

}

const withTranslations = translate(UserProfileTooltip);

export default withTranslations;